import axios from 'axios';
import https from 'https';
import ResponseError from 'utils';


axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

export default () => {
  const axiosInstance = axios.create({
    httpsAgent: new https.Agent({
      rejectUnauthorized: process.env.NODE_ENV !== 'development',
    }),
  });
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 200 && response.data && response.data.status === 'error') {
        return Promise.reject(new ResponseError(response));
      }
      return response.data;
    },
    (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }
      return Promise.reject(error.response.data);
    },
  );
  axiosInstance.interceptors.request.use(
    (config) => {
      const { REACT_APP_API_URL } = process.env;

      return {
        ...config,
        baseURL: REACT_APP_API_URL,
      };
    },
    (error) => Promise.reject(error),
  );
  return axiosInstance;
};
